module.exports = __webpack_public_path__ + "static/img/Group 11271.0fcd6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/Group 11271.png
// module id = sTNS
// module chunks = 1